import { appStore } from "./store";

const initialTitle = document.querySelector('title').innerText;

export const navigateTo = (hash, initialScroll, fromState) => {
  if (initialScroll === undefined) {
    initialScroll = false;
  }

  const hashBit = hash.substring(1);

  if (appStore.selection.curNative) {
    appStore.selection.curNative.active = false;
  }

  let title = initialTitle;

  if (hashBit.startsWith('n_')) {
    const ns = appStore.findNamespace(hashBit);
    if (ns) {
      appStore.selection.curIndex = appStore.viewNativeList.natives.indexOf(ns);

      title = ns.native.name + ' - ' + title;
    }
  } else {
    const native = appStore.findNative(hashBit.substr(1));

    if (native) {
      native.active = true;

      appStore.selection.curNative = native;
      appStore.selection.curIndex = appStore.viewNativeList.natives.indexOf(native);

      appStore.selection.initialScroll = initialScroll;

      title = (native.native.name || native.native.hash) + ' - ' + title;
    }
  }

  if (window.location.search !== hash && !fromState) {
    window.history.pushState({ hash }, title, hash);
  } else if (initialScroll) {
    window.history.replaceState({ hash }, title, hash);
  }

  document.querySelector('title').innerText = title;
};
